import { render, staticRenderFns } from "./ConfiguracionesGenerales.vue?vue&type=template&id=3194b281"
import script from "./ConfiguracionesGenerales.vue?vue&type=script&lang=js"
export * from "./ConfiguracionesGenerales.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionesGenerales.vue?vue&type=style&index=0&id=3194b281&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports